import { FiveStarField } from 'components/inputs/FiveStarField';
import { Typography } from 'omakase';
import { footerContainer } from 'components/profile/reservationPreviewCardFooterCssDefs';
import { preventBubbleOutside } from '@tock/shared/utils/eventUtils';
import { useHistory } from 'react-router';

interface Props {
  /**
   * URL identifier for the business to receive feedback. Required to submit feedback
   */
  businessDomain?: string | null;
  /**
   * Submitted 5 star rating value
   */
  rating?: number | null;
  /**
   * Reservation that is eligible for feedback
   */
  reservationId: number;
}

export const ReservationPreviewCardFooter = ({ businessDomain, rating, reservationId }: Props) => {
  const history = useHistory();
  const isReadOnly = !!rating;

  const handleSelectRating = (e: React.ChangeEvent<{}>, rating: number | null) => {
    if (rating) {
      const url = `/${businessDomain}/reservations/${reservationId}/feedback?rating=${rating}&ratingType=FIVE_POINT_STAR&source=PAST_RESERVATIONS`;
      history.push(url);
    }
  };

  if (!businessDomain && !isReadOnly) {
    return null;
  }

  return (
    <div css={footerContainer}>
      <FiveStarField
        name={`ratingSelection-${reservationId}`}
        onClick={preventBubbleOutside}
        onChange={handleSelectRating}
        readOnly={isReadOnly}
        size="small"
        value={rating}
      />
      <Typography variant="caption">{isReadOnly ? 'Your rating' : 'Not yet rated'}</Typography>
    </div>
  );
};
